import { ContainerModule, interfaces } from 'inversify';
import { ClarificationsStore, IClarificationsStore } from './Clarifications.store';
import { ClarificationsBl, IClarificationsBl } from './services/Clarifications.bl';
import { ClarificationsApiService, IClarificationsApiService } from './services/ClarificationsApi.service';

export const clarificationsModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IClarificationsStore.$).to(ClarificationsStore).inSingletonScope();
  bind(IClarificationsApiService.$).to(ClarificationsApiService).inSingletonScope();
  bind(IClarificationsBl.$).to(ClarificationsBl).inSingletonScope();
});
